import { IAbTestingService } from './ab-testing-service.interface';
import { MatomoAbTesting } from './matomo-ab-testing-service';

export default function abTestingService(): IAbTestingService {
  return MatomoAbTesting;
}
